import appConfig from 'app-config';
const { env } = appConfig;
const prefix = _.get(env, 'DEPLOYMENT_PATH', '').replace(/\/$/, '');

export default {
    name: 'CustomTheme',
    prefix: 'customTheme',
    rootStyle: {
        '--GW-FONT-SANS-SERIF': 'Helvetica,Arial,sans-serif',
        '--GW-COLOR-BRAND-3': '#9f1a65',
        '--GW-COLOR-BRAND-3-CONTRAST': 'var(--GW-COLOR-LIGHT-CONTRAST)',
        '--GW-COLOR-BRAND-3-HOVER': '#9f1a65',
        '--GW-COLOR-BRAND-3-ACTIVE': '#9f1a65',
        '--GW-COLOR-BRAND-3-GRADIENT': '#9f1a65',
        '--GW-COLOR-BRAND-3-GRADIENT-HOVER': '#9f1a65',
        '--GW-COLOR-BRAND-3-GRADIENT-ACTIVE': '#9f1a65',
        '--GW-COLOR-BRAND-1': '#007852',
        '--GW-COLOR-HIGHLIGHT-2': 'white',
        '--GW-COLOR-BRAND-1-CONTRAST': 'var(--GW-COLOR-DARK-CONTRAST)',
        '--GW-COLOR-BRAND-1-HOVER': '#007852',
        '--GW-COLOR-BRAND-1-ACTIVE': '#70a087',
        '--GW-COLOR-BRAND-1-GRADIENT': '#007852',
        '--GW-COLOR-BRAND-1-GRADIENT-HOVER': '#007852',
        '--GW-COLOR-BRAND-1-GRADIENT-ACTIVE': '#70a087',
        '--GW-COLOR-FOCUS-1': 'none',
        '--GW-COLOR-BRAND-2-CONTRAST': 'var(--GW-COLOR-DARK-CONTRAST)',
        '--GW-COLOR-BRAND-2-HOVER': '#9f1a65',
        '--GW-COLOR-BRAND-2-ACTIVE': '#9f1a65',
        '--GW-BOX-SHADOW-FOCUS': 'none',
        '--NEXUS-COLOR-BRAND-1': 'whitesmoke',
        '--application-header-logo-size': '65px',
        '--header-button-focus-border-size': 'var(--GW-BORDER-WIDTH-THICK)',
        '--burger-bars-background-color': 'var(--GW-COLOR-BRAND-1)',
        '--NEXUS-ACCESSIBILITY-OUTLINE-COLOR': '#43b5b3',
        '--app-logo-path': `url(${prefix}/branding/Trillium_Secondary_Logo_Horizontal_RGB.png)`,
        '--app-mobile-logo-path': `url(${prefix}/branding/Trillium_Primary_Logo_RGB.png)`
    },
    componentStyles: {
        Button: {
            button: {
                '--button-hover-bg-image': 'linear-gradient(240deg, #f5f5f5 0%, #f5f5f5 100%)',
                '--button-hover-color': 'var(--GW-COLOR-BRAND-1)',
                '--button-border': 'solid',
                '--button-box-shadow': 'none',
            },
            secondary: {
                '--button-color': 'var(--GW-COLOR-BRAND-1-GRADIENT)',
                '--button-bg-color': 'var(--GW-COLOR-BACKGROUND-1)',
                '--button-bg-image': 'none',
                '--button-border-color': 'var(--GW-COLOR-BRAND-1-GRADIENT)',
                '--button-box-shadow': 'inset 0 0 0 calc(0.125 * var(--GW-SPACING)) var(--GW-COLOR-BRAND-1-GRADIENT), var(--GW-BOX-SHADOW-OUTER-1)',
                '--button-border': 'none',
                '--button-hover-color': 'var(--GW-COLOR-DARK-CONTRAST)',
                '--button-hover-bg-color': 'var(--GW-COLOR-BRAND-1-HOVER)',
                '--button-hover-bg-image': 'linear-gradient(240deg, var(--GW-COLOR-BRAND-1-GRADIENT-HOVER) 0%, var(--GW-COLOR-BRAND-1-HOVER) 100%)',
                '--button-hover-border-color': 'var(--GW-COLOR-BRAND-1-HOVER)',
                '--button-hover-box-shadow': 'var(--button-box-shadow)',
                '--button-active-color': 'var(--GW-COLOR-DARK-CONTRAST)',
                '--button-active-bg-color': 'var(--GW-COLOR-BRAND-1-HOVER)',
                '--button-active-bg-image': 'linear-gradient(240deg, var(--GW-COLOR-BRAND-1-GRADIENT-HOVER) 0%, var(--GW-COLOR-BRAND-1-ACTIVE) 100%)',
                '--button-active-border-color': 'var(--GW-COLOR-BRAND-1-HOVER)',
                '--button-active-box-shadow': 'var(--button-box-shadow)',
                '--button-focus-color': 'var(--GW-COLOR-FOCUS-1-CONTRAST)',
                '--button-focus-bg-color': 'var(--GW-COLOR-BRAND-1)',
                '--button-focus-bg-image': 'linear-gradient(240deg, var(--GW-COLOR-BRAND-1-GRADIENT) 0%, var(--GW-COLOR-BRAND-1) 100%)'                
            },
            tertiary: {
            }
        },
        Panel: {
            panel: {
                '--panel-box-shadow': 'none',
                '--panel-background-color': 'transparent'
            }
        },
        InfoLabel: {
            neutral: {
                '--info-label-bg-color': '#9f1a65',
                '--info-label-color': 'var(--GW-COLOR-ALERT-INFO-CONTRAST)'
            }
        },
        Table: {
            table: {
                padding: 'var(--table-padding-y) 0 var(--table-padding-y) 0'
            },
            row: {},
            tableCell: {
                'vertical-align': 'middle'
            }
        },
        AccordionCard: {
            accordionToggle: {
                height: 'auto',
                'min-height': '50px'
            }
        },
        Checkbox: {
            checkbox: {},
            checkboxIcon: {},
            checkboxElement: {},
            checkboxElementWrapper: {},
            input: {}
        },
        CurrencyField: {
            currency: {}
        },
        DatePickerField: {
            datePicker: {}
        },
        DropdownSelect: {
            valueContainer: {},
            control: {}
        },
        InlineNotification: {
            inlineNotification: {}
        },
        Toggle: {
            toggle: {},
            toggleButton: {},
            active: {}
        },
        FieldComponent: {
            fieldComponent: {},
            left: {},
            reversed: {},
            contentContainer: {},
            fullWidth: {},
            controlReadOnly: {}
        },
        FieldLabel: {
            fieldLabel: {},
            optional: {}
        },
        FieldMessage: {
            fieldMessage: {}
        },
        FileUpload: {
            wrapper: {},
            valueText: {}
        },
        Link: {
            link: {
                color: 'var(--GW-COLOR-TEXT-1)',
                'font-size': 'x-large'
            }
        },
        Stepper: {
            stepper: {},
            button: {}
        },
        TypeaheadMultiSelect: {
            control: {}
        },
        Header: {
            // header: {
            //     '--application-header-header-background-color':' var(--NEXUS-COLOR-BRAND-1)',
            //     'width': '100%',
            //     'z-index': '999',
            //     'height': '100px',
            //     'box-shadow': 'var(--GW-BOX-SHADOW-OUTER-2)',
            //     'overflow-x':'hidden'
            // }
        },
        Card: {
            card: {
            },
            header: {}
        },
        ApplicationHeader: {
            applicationHeaderWrapper: {
                '--application-header-header-background-color': ' var(--NEXUS-COLOR-BRAND-1)',
                position: 'sticky',
                top: 'calc(2.5 * var(--GW-SPACING-XXL))',
                width: '100%',
                'z-index': '100',
                height: 'auto',
                'box-shadow': 'var(--GW-BOX-SHADOW-OUTER-2)'
            },
            applicationLogoTitleLink: {
                '--gw-app-header-img-width': '200px',
                '--gw-app-header-img-height': '70px',
                '--gw-app-header-img-width2': '70px',
                '--gw-app-header-img-height2': '70px',
                width: 'var(--gw-app-header-img-width)',
                height: 'var(--gw-app-header-img-height)',
                'background-image': 'var(--gw-header-image)',
                'background-size': 'contain',
                'background-repeat': 'no-repeat'
            },
            applicationLogo: {
                '--application-header-logo-size': '65px',
            },
            subApplicationHeader: {
                '--nav-item-padding-x': '20px'
            }
        },
        TopNavigation: {
            topNavigation: {
                '--nav-item-padding-x': '30px'
            }
        },
        ImageComponent: {
            imageFigure: {
                'margin-left': 'auto',
                'margin-right': 'auto'
            },
            figure: {
                'margin-left': 'auto',
                'margin-right': 'auto'
            }
        }
    }
};
